<template>
  <div>
    <div class="page-header">
      <h1>Algoritma Klinis</h1>
    </div>
    <div class="content-container">
      <p>Halaman ini sedang dalam pengembangan.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlgoritmaKlinisList',
}
</script>
